// Payment gateways
const paymentGateway = {}
paymentGateway[(paymentGateway['Tarjeta'] = 'STRIPE')] = 'Tarjeta'
paymentGateway[(paymentGateway['OXXO'] = 'OXXO_CONEKTA')] = 'OXXO'
paymentGateway[(paymentGateway['OXXO'] = 'OXXO_FEMSA')] = 'OXXO'
paymentGateway[(paymentGateway['OXXO'] = 'OXXO')] = 'OXXO'
paymentGateway[(paymentGateway['Wallet'] = 'WALLET')] = 'Wallet'
paymentGateway[(paymentGateway['SPEI'] = 'SPEI_CONEKTA')] = 'SPEI'

export default paymentGateway
